export const RATIO_CODE = {
  CLAIM_RATIO: 'RT2017',
  EXPENSE_RATIO: 'RT0420',
  COMBINED_RATIO: 'RT2018',
  CLAIM_AVG: 'RTG2017',
  EXPENSE_AVG: 'RTG0420',
  COMBINED_AVG: 'RTG2018',
}

export const TREND_DATA = [
  {
    value: RATIO_CODE.CLAIM_AVG,
    color: '#EDF5FE',
    width: 'calc(100% - 3px)',
    dotColor: '#006AA6',
    disableFill: false,
  },
  {
    value: RATIO_CODE.EXPENSE_AVG,
    color: '#fef7e2',
    width: 'calc(66% - 3px)',
    dotColor: '#FFCD60',
    disableFill: false,
  },
  {
    value: RATIO_CODE.COMBINED_AVG,
    color: '#f7e6e8',
    width: 'calc(33% - 3px)',
    dotColor: '#FF596A',
    disableFill: false,
  },
  {
    value: RATIO_CODE.CLAIM_RATIO,
    color: '#06a4f9',
    width: 'calc(50% - 3px)',
    dotColor: '#06a4f9',
    disableFill: true,
  },
  {
    value: RATIO_CODE.EXPENSE_RATIO,
    color: '#ffd900',
    width: 'calc(50% - 3px)',
    dotColor: '#ffd900',
    disableFill: true,
  },
  {
    value: RATIO_CODE.COMBINED_RATIO,
    color: '#ff008c',
    width: 'calc(50% - 3px)',
    dotColor: '#ff008c',
    disableFill: true,
  },
]

export const EACH_YEAR_RATIO = [
  {
    id: RATIO_CODE.CLAIM_RATIO,
    industryId: RATIO_CODE.CLAIM_AVG,
    topColor: '#EDF5FE',
    bottomColor: '#006AA6',
  },
  {
    id: RATIO_CODE.EXPENSE_RATIO,
    industryId: RATIO_CODE.EXPENSE_AVG,
    topColor: '#fef7e2',
    bottomColor: '#FFCD60',
  },
  {
    id: RATIO_CODE.COMBINED_RATIO,
    industryId: RATIO_CODE.COMBINED_AVG,
    topColor: '#f7e6e8',
    bottomColor: '#FF596A',
  },
]
